import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Secret Key Listener Component
 * Listens for Ctrl+Shift+Spacebar to redirect to admin login
 */
const SecretKeyListener = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleKeyPress = (event) => {
            // Check for Ctrl+Shift+Spacebar
            if (event.ctrlKey && event.shiftKey && event.key === ' ') {
                event.preventDefault();
                navigate('/admin/login');
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [navigate]);

    return null; // This component doesn't render anything
};

export default SecretKeyListener;
